<form #form class="basic-text" [formGroup]="signupForm">
  <div>
    <div class="row" style="margin-bottom: 2vh">
      <div class="col-md-6" style="padding-right: 2vw">
        <markant-input
          #required
          ngDefaultControl
          type="text"
          class="markant-input"
          label="{{ STARTUP_NAME_LABEL }}"
          name="name"
          formControlName="name"
          maxlength="255"
          helper="Pflichtfeld"
          required
        ></markant-input>
      </div>

      <div class="col-md-6" style="padding-left: 2vw">
        <markant-input
          ngDefaultControl
          type="text"
          class="markant-input"
          label="Markenname (optional)"
          name="nickname"
          formControlName="nickname"
        ></markant-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" style="padding-right: 2vw">
        <div class="row">
          <div class="col-md-12">
            <h4>Deine Firmenadresse</h4>
          </div>

          <div class="col-md-12">
            <markant-input
              #required
              ngDefaultControl
              type="text"
              class="markant-input"
              label="Straße"
              name="street"
              formControlName="street"
              maxlength="255"
              helper="Pflichtfeld"
              required
            ></markant-input>
          </div>

          <div class="col-md-4">
            <markant-input
              #required
              ngDefaultControl
              id="zip"
              type="text"
              class="markant-input"
              label="PLZ"
              name="zipCode"
              formControlName="zipCode"
              maxlength="50"
              helper="Pflichtfeld"
              required
            ></markant-input>
          </div>
          <div class="col-md-8">
            <markant-input
              #required
              ngDefaultControl
              type="text"
              class="markant-input"
              label="Stadt"
              name="city"
              formControlName="city"
              maxlength="255"
              helper="Pflichtfeld"
              required
            ></markant-input>
          </div>

          <div class="col-md-12">
            <markant-select
              #required
              ngDefaultControl
              formControlName="countryISOCode"
              label="Land"
              name="countryISOCode"
              (valueChange)="onCountryChange($event)"
              maxlength="3"
              helper="Pflichtfeld"
              required
            >
              <markant-select-option *ngFor="let c of countries" [value]="c.iso">{{ c.nameDe }}</markant-select-option>
            </markant-select>
          </div>

          <div class="col-md-12">
            <markant-input
              #gln
              ngDefaultControl
              type="text"
              class="markant-input"
              label="GLN"
              name="gln"
              formControlName="gln"
              helper="Pflichtfeld"
              required
            ></markant-input>
          </div>
        </div>
      </div>
      <div class="col-md-6 kontaktdaten-wrapper">
        <div class="col-md-12">
          <h4>Deine Kontaktdaten</h4>
        </div>
        <div class="row">
          <div class="col-md-12" id="anspracheHeader">
            <div class="ansprache col-md-4">
              <markant-select ngDefaultControl formControlName="title" label="Ansprache">
                <markant-select-option [value]="Title.MALE">Herr</markant-select-option>
                <markant-select-option [value]="Title.FEMALE">Frau</markant-select-option>
                <markant-select-option [value]="Title.DIVERSE">Keine Anrede</markant-select-option>
              </markant-select>
            </div>
            <div class="ansprache col-md-4">
              <markant-input
                #required
                ngDefaultControl
                label="Vorname"
                class="markant-input"
                name="firstName"
                formControlName="firstName"
                maxlength="255"
                helper="Pflichtfeld"
                required
              ></markant-input>
            </div>

            <div class="ansprache col-md-4">
              <markant-input
                #required
                ngDefaultControl
                class="markant-input"
                label="Nachname"
                name="lastName"
                formControlName="lastName"
                maxlength="255"
                helper="Pflichtfeld"
                required
              ></markant-input>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <markant-input
            #required
            ngDefaultControl
            name="email"
            class="markant-input"
            type="text"
            label="E-Mail"
            formControlName="email"
            helper="Pflichtfeld"
            [pattern]="this.emailRegex"
            required
          ></markant-input>
        </div>

        <div class="phone-wrapper">
          <div class="col-md-3 country-code">
            <markant-input
              #required
              ngDefaultControl
              type="tel"
              appRestrictInput
              class="markant-input"
              [allowedInput]="'^[0-9]*$'"
              pattern="^[0-9]*$"
              helper="Pflichtfeld"
              name="companyPhoneCountryCode"
              formControlName="companyPhoneCountryCode"
              label="Vorwahl"
              maxlength="4"
              required
            >
              <markant-icon slot="markant-icon-leading" src="./assets/svg/m_add-filled.svg"></markant-icon>
            </markant-input>
          </div>
          <div class="col-md-9">
            <markant-input
              #required
              ngDefaultControl
              type="tel"
              appRestrictInput
              class="markant-input"
              [allowedInput]="'^[0-9]*$'"
              pattern="^[0-9]*$"
              helper="Pflichtfeld"
              name="companyPhone"
              formControlName="companyPhone"
              label="Telefonnummer"
              maxlength="15"
              required
            >
            </markant-input>
          </div>
        </div>

        <div class="phone-wrapper">
          <div class="col-md-3 country-code">
            <markant-input
              #required
              ngDefaultControl
              type="tel"
              appRestrictInput
              class="markant-input"
              [allowedInput]="'^[0-9]*$'"
              pattern="^[0-9]*$"
              helper="Pflichtfeld"
              name="contactPersonPhoneCountryCode"
              formControlName="contactPersonPhoneCountryCode"
              label="Vorwahl"
              maxlength="4"
              required
            >
              <markant-icon slot="markant-icon-leading" src="./assets/svg/m_add-filled.svg"></markant-icon>
            </markant-input>
          </div>

          <div class="col-md-9">
            <markant-input
              #required
              ngDefaultControl
              type="tel"
              class="markant-input"
              appRestrictInput
              [allowedInput]="'^[0-9]*$'"
              pattern="^[0-9]*$"
              helper="Pflichtfeld"
              label="Tel. Kontaktperson"
              name="contactPersonPhone"
              formControlName="contactPersonPhone"
              maxlength="15"
              required
            ></markant-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
